export default __webpack_public_path__ + "static/costume_f_robe-56ce5ee601d8f8d249caa8805055a3b2.png";